import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import FormSection from 'components/sales/formSection/formSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Checkbox from 'components/sales/Input/checkbox/checkbox';

const Assignee = ({
  isBulkAssignment = false,
  assigneeList,
  handleValue,
  leadId,
  siteId,
  baAssignee = false,
  showComment = true,
  isSiteAssignPending=false
}) => {
  const inputs = {
    user_id: '',
    self_assigned: false,
  };
  const [isRequired, setRequired] = useState(false);
  const [formData, setData] = useState(inputs);
  const [dropDownList, setDropdown] = useState();
  const [title, setTitle] = useState(localization.selectAssignee)

  useEffect(() => {
    if (assigneeList) setDropdown(assigneeList);
  }, [assigneeList]);

  const handleData = () => {
    if (formData.user_id !== '' || formData.self_assigned === true) {
      setRequired(false);
      if (formData.user_id !== '') {
        if (leadId) {
          handleValue({
            ...formData,
            self_assigned: formData.self_assigned === true ? 1 : 0,
            lead_id: leadId,
          });
        } else if (siteId) {
          handleValue({
            ...formData,
            self_assigned: formData.self_assigned === true ? 1 : 0,
            site_id: siteId,
          });
        }
      } else {
        if (leadId) {
          handleValue({
            self_assigned: formData.self_assigned === true ? 1 : 0,
            lead_id: leadId,
          });
        } else if (siteId) {
          handleValue({
            self_assigned: formData.self_assigned === true ? 1 : 0,
            site_id: siteId,
          });
        }
      }
    } else {
      setRequired(true);
      handleValue(null);
    }
  };

  useEffect(() => {
    if(isSiteAssignPending){
      setTitle(`${localization.selectAssignee} (Reassign Pending)`)
    }
  }, [isSiteAssignPending])

  useEffect(() => {
    handleData();
  }, [formData]);
  return (
    <FormSection
      title={
        !isBulkAssignment
          ? title
          : baAssignee
          ? title
          : ''
      }
    >
      <div className="row">
        {assigneeList &&  assigneeList.site_data && (
          <div className="col-md-12 col-xs-12 d-flex">
            <h4>
             {assigneeList.site_data.client_name} ({assigneeList.site_data.site_no })</h4>
          </div>
        )}
      </div>
      <div className="details-listing">
        {!isBulkAssignment && (
          <div className="details-list">
            <strong className="data-title">
              {localization.currentAssigne}
            </strong>

            <span className="data-details">
              {dropDownList?.current_assignee_name
                ? dropDownList.current_assignee_name
                : 'N/A'}
            </span>
          </div>
        )}
      </div>
      {!formData.self_assigned && (
        <DropDownInput
          label={localization.assignTo}
          data={
            dropDownList && dropDownList.reportees
              ? dropDownList.reportees
              : dropDownList && dropDownList.length > 0
              ? dropDownList
              : []
          }
          getIdValue={(value) => setData({ ...formData, user_id: value.id })}
          disabled={formData.self_assigned !== false ? true : false}
        />
      )}
      {!isBulkAssignment && formData.user_id === '' && (
        <Checkbox
          label={localization.assignToSelf}
          type="checkbox"
          errorMsg={localization.isRequired}
          onChange={(val) => setData({ ...formData, self_assigned: val })}
          disabled={formData.user_id !== '' ? true : false}
        />
      )}
      {isRequired === true && showComment == true ? (
        <label style={{ color: 'red' }}>{localization.oneRequired}</label>
      ) : null}
    </FormSection>
  );
};

Assignee.propTypes = {};

export default Assignee;
